export function setupCxgenie(item, locale) {
  if (!item?.link) return null
  const cxgenieScript = document.createElement('script')
  cxgenieScript.src = item.link
  cxgenieScript.setAttribute('data-aid', item.id)
  cxgenieScript.setAttribute('data-lang', locale)
  cxgenieScript.setAttribute('data-hide-widget-button', 'true')
  document.head.appendChild(cxgenieScript)

  let loaded = false
  let callback = null

  function cxGenieCall(action, param) {
    if (loaded) {
      switch (action) {
        case 'maximize':
          window.openCXGenieChatWidget()
          break
        case 'minimize':
          window.closeCXGenieChatWidget()
          break
        case 'hide':
          window.closeCXGenieChatWidget()
          break
        case 'setUser':
          console.log('CX Genie Can not set user.')
          break
        default:
          console.log('Unknown CX Genie Action')
          break
      }
    } else {
      callback = function () {
        cxGenieCall(action, param)
      }
    }
  }

  cxgenieScript.onload = () => {
    loaded = true
    console.log('[Customer Service] CX Genie Ready')
    if (callback) {
      callback()
      callback = null
    }
  }

  return {
    maximize() {
      try {
        cxGenieCall('maximize')
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
    minimize() {
      try {
        cxGenieCall('minimize')
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
    hide() {
      try {
        cxGenieCall('hide')
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
    setUser(uidSite) {
      try {
        cxGenieCall('setUser', { user_id: uidSite, user_name: uidSite })
      } catch (error) {
        console.log('CX Genie not ready yet')
      }
    },
  }
}
